import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { GetCheckSelect }   from '../../../actions/scopoAction';

class menu_sub extends Component {

  
    renderLista(){
    
        return (<div className="sub-menu-pag">
                  <div className="container"> 
                    <div className="menu">
                       {this.props.listaSubMenuScopo.map((elem,i)=>{ return <a key={i} href={void(0)} onClick={()=>this.props.GetCheckSelect(elem.link)} className={`btn btn-link btn-menu btn-action-${elem.link}`}>{elem.nome}</a> })}  
                     </div>
                   </div> 
                </div>);
    }

    render(){
     
        const listaSubMenu = this.props.listaSubMenuScopo.length;
        return (
         <div>
           {listaSubMenu ? this.renderLista() : "" }
          </div>
        );
    }
}

function mapStateToProps(state){
  
    return {
             menu              : state.configReducer.menu,
             listaSubMenuScopo : state.scopoReducer.allListaSubMenu
           };
}

export default connect(mapStateToProps,{GetCheckSelect})(menu_sub);



// WEBPACK FOOTER //
// ./src/components/professor/menu/menu_sub.js